'use strict';
import angular from 'angular';
import _ from 'lodash';

import deviceCapabilityHtmlUrl from './views/deviceCapability.list.html';

var app = angular.module('deviceCapability.component', []);

app.component('deviceCapability', {
    bindings: {
        showActions: '=',
        selectedData: '=',
        clusterId: '='
    },
    templateUrl: deviceCapabilityHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService, FormService) {
        var self = this;

        self.capabilitySearch = "";
        self.deviceCapabilities = [];
        self.devicesWidget = [];
        self.capabilitiesIncluded =[];
        self.capabilitiesExcluded = [];
        self.capabilitiesIncludedView = [];
        self.capabilitiesExcludedView = [];

        self.changeIncludeExclude = function(item, criteria, data, type) {
            
            self.devicesWidget = data;
            var index = self.devicesWidget.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    self.devicesWidget[index].criteria = 'include';
                    self.devicesWidget[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    self.devicesWidget[index].criteria = 'exclude';
                    self.devicesWidget[index].criteria_link = 'excluded';
                } else {
                    self.devicesWidget[index].criteria = '';
                    self.devicesWidget[index].criteria_link = 'include';
                }
                if(type === 'capability') {
                    var selIndex = _.findIndex(self.selectedData.deviceCapabilities, { id: self.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedData.deviceCapabilities[selIndex] = self.devicesWidget[index];
                    } else {
                        self.selectedData.deviceCapabilities.push(self.devicesWidget[index]);
                    }
                    self.capabilitiesIncluded = _.filter(self.selectedData.deviceCapabilities, function(item){ return item.criteria == 'include'; }); 
                    self.capabilitiesExcluded = _.filter(self.selectedData.deviceCapabilities, function(item){ return item.criteria == 'exclude'; }); 
                }         
            }
        }

        self.removeDevice = function(item, selectedCapability, capabilityData) {
            var selIndex = selectedCapability.indexOf(item);
            if (selIndex >= 0) {
                selectedCapability.splice(selIndex, 1);
                var itemIndex;
                if(item.criteria=='include'){
                     itemIndex = self.capabilitiesIncluded.indexOf(item);
                     self.capabilitiesIncluded.splice(itemIndex, 1);
                }
                else{
                     itemIndex = self.capabilitiesExcluded.indexOf(item);
                     self.capabilitiesExcluded.splice(itemIndex, 1);
                }
            }
            var index = _.findIndex(capabilityData, { id: item.id });
            if (index >= 0) {
                capabilityData[index].criteria = '';
                capabilityData[index].criteria_link = 'include';
            }
        }

        self.clearSelectedCapabilities = function(capabilityData){
            self.selectedData.deviceCapabilities =[];
            self.includeOrExcludeCategory = null;
            self.capabilitiesIncluded =[];
            self.capabilitiesExcluded = [];
            _.map(capabilityData, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
            });
        };


        /*
        * get device capabilities lookup contents
        */
        self.getDeviceCapabilitiesByContentKey = function() {
            ProductService.getDeviceCapabilitiesByContentKey({clusterId: self.clusterId, contentKey: 'dfp_device_capability'}).then(function(success) {
                if(success && success.lookupContents && success.lookupContents.length > 0) {
                    _.each(success.lookupContents, function(content) {
                        var capability = {};
                        capability.id = content.id;
                        capability.name = content.lookup_value;
                        capability.criteria = "";
                        capability.criteria_link = "include";
                        self.deviceCapabilities.push(capability);
                    })
                    processCapabilitiesData('dfp_device_capability');
                }
            }, function(error) {});
        }

        var processCapabilitiesData = function(contentKey) {
            if(self.editMode && self.selectedData) {
                var capabilityList = [];
                var subList = [];

                if((self.selectedData.deviceCapabilities && self.selectedData.deviceCapabilities.length > 0)) {
                    if(contentKey === 'dfp_device_capability') {
                        capabilityList = self.deviceCapabilities;
                        subList = self.selectedData.deviceCapabilities;
                        self.capabilitiesIncluded = _.filter(self.selectedData.deviceCapabilities, function(item){ return item.criteria == 'include'; }); 
                        self.capabilitiesExcluded = _.filter(self.selectedData.deviceCapabilities, function(item){ return item.criteria == 'exclude'; });
                    }
                    processCapabilities(capabilityList, subList);
                }
            }
        }

        var processCapabilities = function(totalList, subList) {
            _.each(totalList, function(category) {
                _.each(subList, function(device) {
                    if(device.id == category.id) {
                        category.criteria = device.criteria;
                        category.criteria_link = device.criteria_link;
                    }
                })
            })
        }
        
        self.initComponent = function() {
            if(self.selectedData && !_.isEmpty(self.selectedData)) {
                if(FormService.isValidJsonString(self.selectedData)){
                    self.selectedData = JSON.parse(self.selectedData);
                }
                if(self.showActions){
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getDeviceCapabilitiesByContentKey();
                }else {
                    self.editMode = false;
                    self.enableViewMode = true;
                    self.capabilitiesIncludedView = _.filter(self.selectedData.deviceCapabilities, function (item) { return item.criteria == 'include'; });
                    self.capabilitiesExcludedView = _.filter(self.selectedData.deviceCapabilities, function (item) { return item.criteria == 'exclude'; });
                }
            } else {
                self.selectedData = {
                    deviceCapabilities: []
                };
                self.enableViewMode = false;
                self.getDeviceCapabilitiesByContentKey();
            }
        };

        self.initComponent();
    }
});